import React from 'react'
import { Button } from '@components'
import { FaExternalLinkAlt } from 'react-icons/fa'
import styled from 'styled-components'

type LinkFallbackToastProps = {
  href: string
  onDismiss: () => void
  downloadFilename?: string
  message: React.ReactNode
  buttonLabel: React.ReactNode
}

export const LinkFallbackToast: React.FC<LinkFallbackToastProps> = ({
  href,
  onDismiss,
  downloadFilename,
  message,
  buttonLabel
}) => (
  <StyledPopupBlockedWrapper>
    {message}

    <a
      href={href}
      download={downloadFilename}
      target={downloadFilename ? undefined : '_blank'}
      rel={downloadFilename ? undefined : 'noreferrer'}
    >
      <Button
        intent="primary"
        isSecondary
        icon={<FaExternalLinkAlt />}
        type="button"
        onClick={onDismiss}
      >
        {buttonLabel}
      </Button>
    </a>
  </StyledPopupBlockedWrapper>
)

const StyledPopupBlockedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}rem;

  a {
    display: flex;
  }

  button {
    flex: 1;
    width: 100%;
  }
`
